<div class="schedule-navbar">
    <div class="content">
        <p class="large">
            <i class="fa-regular fa {{ entitytypes[mainEntityType?.key]?.icon }}"></i>
            &nbsp;{{ entitytypes[mainEntityType?.key]?.name }}
        </p>
        <p class="small">
            {{ begindate | date: 'EEEE d MMM yyyy' }} - {{ begindate | date: 'HH:mm' }} - {{ enddate | date: 'HH:mm' }}
        </p>
    </div>
</div>

<router-outlet></router-outlet>
